import React from 'react';
import PropTypes from 'prop-types';
import { Stack, mergeStyles } from '@bingads-webui-react/fabric-control';
import classNames from 'classnames';
import { Header, CouponDescription, DefaultButton, PrimaryButton } from './components';

const confirmationButtonStyles = mergeStyles({
  marginRight: 8,
});

export const Claimed = ({
  coupon, i18n, onConfirm, onDismiss, steps,
}) => (
  <div>
    <Header text={i18n.getString('Claimed_Title')} i18n={i18n} onCloseButtonClick={onDismiss} />
    <CouponDescription coupon={coupon} i18n={i18n} steps={steps} />
    <Stack horizontal horizontalAlign="end" verticalAlign="center">
      <PrimaryButton text={i18n.getString('Claimed_ConfirmationButton')} onClick={onConfirm} className={classNames(confirmationButtonStyles, 'confirmation-button')} />
      <DefaultButton text={i18n.getString('Claimed_DontShowAgain')} onClick={onDismiss} className="dont-show-again-button" />
    </Stack>
  </div>);

Claimed.propTypes = {
  coupon: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({
    stepIndex: PropTypes.number,
    description: PropTypes.string,
    icon: PropTypes.string,
  })).isRequired,
};
